import { createContext, ReactNode, useContext, useState } from 'react'
import { NodeType } from '../../../definitions/Nodes'

const DnDContext = createContext<[NodeType, (type: NodeType) => void]>([null, () => {}])

export const DnDProvider = ({ children }: { children: ReactNode }) => {
    const [type, setType] = useState<NodeType>(null)

    return (
        <DnDContext.Provider value={[type, setType]}>
            {children}
        </DnDContext.Provider>
    )
}

export default DnDContext

export const useDnD = () => {
    return useContext(DnDContext)
}
